
export function calculateClusterFadeExpectancy(simpleStats, clusterOutcomes, sequenceStats, waves, options = {
  stopMultiplier: 1,
  takeShift: 0,
  commission: 0.001,
  averagingMode: 'median',
  clusterPathIndex: 3,
  enterDistMultIndex: 1,
  exitDistMultIndex: 1,
}) {
  try {
    const { averagingMode } = options;
    const clusterPathIndex = options.clusterPathIndex || 3
    const enterDistMultIndex = options.enterDistMultIndex || 1
    const exitDistMultIndex = options.exitDistMultIndex || 1

    let valueKey = 'median'
    let distributionKey = 'mad'
    let distributionKeyPos = 'madPos'
    let distributionKeyNeg = 'madNeg'
    if (averagingMode === 'median') {
      valueKey = 'median'
      distributionKey = 'mad'
      distributionKeyPos = 'madPos'
      distributionKeyNeg = 'madNeg'
    } else if (averagingMode === 'avg') {
      valueKey = 'avg'
      distributionKey = 'stdDev'
      distributionKeyPos = 'stdDevPos'
      distributionKeyNeg = 'stdDevNeg'
    }

    const lastWave = waves[waves.length - 1];
    const prevWave = waves[waves.length - 2];
    const prePrevWave = waves[waves.length - 3];

    const currentType = clusterOutcomes.currentType === 'move' ? 'currentMove' : 'currentPullback'

    // historical 1 option
    const prevPath = clusterOutcomes.prev[clusterPathIndex]
    // current 2 options (pullback could become move)
    const currentPullback = clusterOutcomes.currentPullback[clusterPathIndex]
    const currentMove = clusterOutcomes.currentMove[clusterPathIndex]
    const currentReal = clusterOutcomes[currentType][clusterPathIndex]
    // next 4 options: next Type1 pre Type2
    // const nextPullbackPullback = clusterOutcomes.nextPullbackPullback[clusterPathIndex]
    // const nextPullbackMove = clusterOutcomes.nextPullbackMove[clusterPathIndex]
    // const nextMovePullback = clusterOutcomes.nextMovePullback[clusterPathIndex]
    // const nextMoveMove = clusterOutcomes.nextMoveMove[clusterPathIndex]


    const calculateOpts = {
      valueKey,
      distributionKey,
      distributionKeyPos,
      distributionKeyNeg,
      clusterPathIndex,
      enterDistMultIndex,
      exitDistMultIndex,
    }

    // ****************************************
    // check prev clusters and outcome
    // compare with current variants
    // ****************************************

    // ****************************************
    // PREV WAVE
    // ****************************************
    const prevOutcomeFallbacks = {
      move: simpleStats.move[prePrevWave.direction],
      pullback: simpleStats.pullback[prePrevWave.direction],
    }

    // const prevSequencePrediction = predictSequence(waves.slice(-4, -1), sequenceStats);
    const prevResultsPercent = calculateClusterPercentDetails(prevPath.deltaPercent, prevOutcomeFallbacks, calculateOpts)
    const clusterExpectancyPrevPercent = getClusterExpectancy(prevResultsPercent, options)

    const prevResultsRatio = calculateClusterRatioDetails(prevPath.deltaRatioPrev, prevOutcomeFallbacks, calculateOpts)
    const prevResultsRatioConverted = ratioToPercentDetails(prevResultsRatio, prePrevWave.deltaPercent)
    const clusterExpectancyPrevRatio = getClusterExpectancy(prevResultsRatioConverted, options)
    // console.log('**********************************')
    // console.log('prevSequencePrediction', prevSequencePrediction)
    // console.log('prev Results', prevResultsPercent, prevResultsRatioConverted, prevResultsRatio)

    // const closestPrevResultsPercent = findClosestClusters(prevResultsPercent, prevWave, calculateOpts)
    // console.log('closestPrevResultsPercent', closestPrevResultsPercent)
    // const closestPrevResultsRatioConverted = findClosestClusters(prevResultsRatioConverted, prevWave, calculateOpts)
    // console.log('closestPrevResultsRatioConverted', closestPrevResultsRatioConverted)

    // console.log('Prev clusterExpectancyResults', clusterExpectancyPrev)

    // ****************************************
    // CURRENT WAVE
    // ****************************************

    // Outcome Fallbacks from SimpleStats 
    // detailed path stats.sequences.key  .up || .down
    // {lastWave.type} {lastWave.direction} After {prevWave.type}
    // pullbackPostMove pullbackPostPullback
    // movePostMove movePostPullback

    const currentOutcomeFallbacks = {
      move: simpleStats.move[prevWave.direction],
      pullback: simpleStats.pullback[prevWave.direction],
    }

    // const currentSequencePrediction = predictSequence(waves.slice(-3), sequenceStats);
    const currentResultsPercent = calculateClusterPercentDetails(currentReal.deltaPercent, currentOutcomeFallbacks, calculateOpts)
    const clusterExpectancyCurrentPercent = getClusterExpectancy(currentResultsPercent, options)

    const currentResultsRatio = calculateClusterRatioDetails(currentReal.deltaRatioPrev, currentOutcomeFallbacks, calculateOpts)
    const currentResultsRatioConverted = ratioToPercentDetails(currentResultsRatio, prevWave.deltaPercent)
    const clusterExpectancyCurrentRatio = getClusterExpectancy(currentResultsRatioConverted, options)
    // console.log('**********************************')
    // console.log('currentSequencePrediction', currentSequencePrediction)
    // console.log('currentReal Results', currentResultsPercent, currentResultsRatioConverted, currentResultsRatio)

    // const closestCurrentResultsPercent = findClosestClusters(currentResultsPercent, lastWave, calculateOpts)
    // console.log('closestCurrentResultsPercent', closestCurrentResultsPercent)
    // const closestCurrentResultsRatioConverted = findClosestClusters(currentResultsRatioConverted, lastWave, calculateOpts)
    // console.log('closestCurrentResultsRatioConverted', closestCurrentResultsRatioConverted)


    // console.log('currentReal clusterExpectancyResults', clusterExpectancyCurrent)

    // ****************************************
    // PULLBACK AND MOVE SCENARIOS
    // ****************************************
    const currentPullbackResultsPercent = calculateClusterPercentDetails(currentPullback.deltaPercent, currentOutcomeFallbacks, calculateOpts)
    const clusterExpectancyCurrentPullbackPercent = getClusterExpectancy(currentPullbackResultsPercent, options)

    const currentPullbackResultsRatio = calculateClusterRatioDetails(currentPullback.deltaRatioPrev, currentOutcomeFallbacks, calculateOpts)
    const currentPullbackResultsRatioConverted = ratioToPercentDetails(currentPullbackResultsRatio, prevWave.deltaPercent)
    const clusterExpectancyCurrentPullbackRatio = getClusterExpectancy(currentPullbackResultsRatioConverted, options)
    // console.log('**********************************')
    // console.log('currentPullback Results', currentPullbackResultsPercent, currentPullbackResultsRatioConverted, currentPullbackResultsRatio)

    // ****************************************
    const currentMoveResultsPercent = calculateClusterPercentDetails(currentMove.deltaPercent, currentOutcomeFallbacks, calculateOpts)
    const clusterExpectancyCurrentMovePercent = getClusterExpectancy(currentMoveResultsPercent, options)
    // 
    const currentMoveResultsRatio = calculateClusterRatioDetails(currentMove.deltaRatioPrev, currentOutcomeFallbacks, calculateOpts)
    const currentMoveResultsRatioConverted = ratioToPercentDetails(currentMoveResultsRatio, prevWave.deltaPercent)
    const clusterExpectancyCurrentMoveRatio = getClusterExpectancy(currentMoveResultsRatioConverted, options)
    // console.log('**********************************')
    // console.log('currentMove Results', currentMoveResultsPercent, currentMoveResultsRatioConverted, currentMoveResultsRatio)

    // ****************************************
    // NEXT WAVE
    // ****************************************

    // console.log('**********************************')


    return {
      prevPercent: clusterExpectancyPrevPercent,
      prevRatio: clusterExpectancyPrevRatio,
      currentPercent: clusterExpectancyCurrentPercent,
      currentRatio: clusterExpectancyCurrentRatio,
      currentPullbackPercent: clusterExpectancyCurrentPullbackPercent,
      currentPullbackRatio: clusterExpectancyCurrentPullbackRatio,
      currentMovePercent: clusterExpectancyCurrentMovePercent,
      currentMoveRatio: clusterExpectancyCurrentMoveRatio,
    }
  } catch (e) {
    console.error("Error calculating expectancy", e);
    return null;
  }
}

function calculateClusterPercentDetails(clusterGroup, fallbacks, calculateOpts) {
  const {
    valueKey,
    distributionKey,
    distributionKeyPos,
    distributionKeyNeg,
    enterDistMultIndex,
    exitDistMultIndex,
  } = calculateOpts

  const details = {
    clusters: [],
  }

  const clusteredSum = clusterGroup.clusters.reduce((acc, val) => acc + val.stats.count, 0);
  const clusteredTotal = clusteredSum + clusterGroup.noise.length

  for (const cluster of clusterGroup.clusters) {
    const prob = cluster.stats.count / clusteredTotal
    const dpr = cluster.stats[valueKey]
    const dev = cluster.stats[distributionKey]
    const dist = cluster.stats.distribution[distributionKey]
    const distPos = cluster.stats.distribution[distributionKeyPos]
    const distNeg = cluster.stats.distribution[distributionKeyNeg]
    const minDpr = dpr - dev * enterDistMultIndex
    const maxDpr = dpr + dev * enterDistMultIndex
    const baseProb = prob * distPos[0]
    const minProb = prob * (1 - distNeg[enterDistMultIndex])
    const maxProb = prob * distPos[enterDistMultIndex]

    let pb = cluster.outcomes.pullback
    if (!pb.count) {
      pb = fallbacks.pullback
    }
    const outPullbackProb = pb.count / cluster.stats.count
    const outPullbackDpr = pb.deltaPercent[valueKey]
    const outPullbackDev = pb.deltaPercent[distributionKey]
    const outPullbackDist = pb.deltaPercent.distribution[distributionKey]
    const outPullbackDistPos = pb.deltaPercent.distribution[distributionKeyPos]
    const outPullbackDistNeg = pb.deltaPercent.distribution[distributionKeyNeg]
    const outPullbackTotalProb = prob * outPullbackProb
    const outPullbackMinDpr = outPullbackDpr - outPullbackDev * exitDistMultIndex
    const outPullbackMaxDpr = outPullbackDpr + outPullbackDev * exitDistMultIndex
    const outPullbackBaseProb = outPullbackTotalProb * outPullbackDistPos[0]
    const outPullbackMinProb = outPullbackTotalProb * (1 - outPullbackDistNeg[exitDistMultIndex])
    const outPullbackMaxProb = outPullbackTotalProb * outPullbackDistPos[exitDistMultIndex]
    const outPullbackMaxDiff = pb.maxDiffPercent[valueKey]
    const outPullbackMaxDiffDev = pb.maxDiffPercent[distributionKey]

    let mv = cluster.outcomes.move
    if (!mv.count) {
      mv = fallbacks.move
    }
    const outMoveProb = mv.count / cluster.stats.count
    const outMoveDpr = mv.deltaPercent[valueKey]
    const outMoveDev = mv.deltaPercent[distributionKey]
    const outMoveDist = mv.deltaPercent.distribution[distributionKey]
    const outMoveDistPos = mv.deltaPercent.distribution[distributionKeyPos]
    const outMoveDistNeg = mv.deltaPercent.distribution[distributionKeyNeg]
    const outMoveTotalProb = prob * outMoveProb
    const outMoveMinDpr = outMoveDpr - outMoveDev * exitDistMultIndex
    const outMoveMaxDpr = outMoveDpr + outMoveDev * exitDistMultIndex
    const outMoveBaseProb = outMoveTotalProb * outMoveDistPos[0]
    const outMoveMinProb = outMoveTotalProb * (1 - outMoveDistNeg[exitDistMultIndex])
    const outMoveMaxProb = outMoveTotalProb * outMoveDistPos[exitDistMultIndex]
    const outMoveMaxDiff = mv.maxDiffPercent[valueKey]
    const outMoveMaxDiffDev = mv.maxDiffPercent[distributionKey]

    const result = {
      initial: {
        count: cluster.stats.count,
        prob,
        dpr,
        dev,
        dist,
        distPos,
        distNeg,
        minDpr,
        maxDpr,
        baseProb,
        minProb,
        maxProb,
      },
      outcomes: {
        pullback: {
          count: cluster.outcomes.pullback.count, // pb.count,
          prob: outPullbackProb,
          dpr: outPullbackDpr,
          dev: outPullbackDev,
          dist: outPullbackDist,
          distPos: outPullbackDistPos,
          distNeg: outPullbackDistNeg,
          totalProb: outPullbackTotalProb,
          minDpr: outPullbackMinDpr,
          maxDpr: outPullbackMaxDpr,
          baseProb: outPullbackBaseProb,
          minProb: outPullbackMinProb,
          maxProb: outPullbackMaxProb,
          maxDiff: outPullbackMaxDiff,
          maxDiffDev: outPullbackMaxDiffDev,
        },
        move: {
          count: cluster.outcomes.move.count, //mv.count,
          prob: outMoveProb,
          dpr: outMoveDpr,
          dev: outMoveDev,
          dist: outMoveDist,
          distPos: outMoveDistPos,
          distNeg: outMoveDistNeg,
          totalProb: outMoveTotalProb,
          minDpr: outMoveMinDpr,
          maxDpr: outMoveMaxDpr,
          baseProb: outMoveBaseProb,
          minProb: outMoveMinProb,
          maxProb: outMoveMaxProb,
          maxDiff: outMoveMaxDiff,
          maxDiffDev: outMoveMaxDiffDev,
        },
      },
    }

    details.clusters.push(result)


    // console.log('--------------------------------')
    // console.log('prediction', 'probability', prob * 100, 'xR', dpr, 'dist', dist, 'minDpr', minDpr, 'minProb', minProb, 'maxDpr', maxDpr, 'maxProb', maxProb)
    // console.log('outPullback', 'probability', outPullbackTotalProb * 100, 'xR', outPullbackDpr, 'dist', outPullbackDist,
    //   'minDpr', outPullbackMinDpr, 'minProb', outPullbackMinProb, 'maxDpr', outPullbackMaxDpr, 'maxProb', outPullbackMaxProb)
    // console.log('outMove', 'probability', outMoveTotalProb * 100, 'xR', outMoveDpr, 'dist', outMoveDist, outMoveDist, 'minDpr',
    //   outMoveMinDpr, 'minProb', outMoveMinProb, 'maxDpr', outMoveMaxDpr, 'maxProb', outMoveMaxProb)
  }

  return details

}

function calculateClusterRatioDetails(clusterGroup, fallbacks, calculateOpts) {
  const {
    valueKey,
    distributionKey,
    distributionKeyPos,
    distributionKeyNeg,
    enterDistMultIndex,
    exitDistMultIndex,
  } = calculateOpts

  const details = {
    clusters: [],
  }

  const clusteredSum = clusterGroup.clusters.reduce((acc, val) => acc + val.stats.count, 0);
  const clusteredTotal = clusteredSum + clusterGroup.noise.length

  for (const cluster of clusterGroup.clusters) {
    const prob = cluster.stats.count / clusteredTotal
    const dpr = cluster.stats[valueKey]
    const dev = cluster.stats[distributionKey]
    const dist = cluster.stats.distribution[distributionKey]
    const distPos = cluster.stats.distribution[distributionKeyPos]
    const distNeg = cluster.stats.distribution[distributionKeyNeg]
    const minDpr = dpr - dev * enterDistMultIndex
    const maxDpr = dpr + dev * enterDistMultIndex
    const baseProb = prob * distPos[0]
    const minProb = prob * (1 - distNeg[enterDistMultIndex])
    const maxProb = prob * distPos[enterDistMultIndex]

    let pb = cluster.outcomes.pullback
    if (!pb.count) {
      pb = fallbacks.pullback
    }
    const outPullbackProb = pb.count / cluster.stats.count
    const outPullbackDpr = pb.deltaRatioPrev[valueKey]
    const outPullbackDev = pb.deltaRatioPrev[distributionKey]
    const outPullbackDist = pb.deltaRatioPrev.distribution[distributionKey]
    const outPullbackDistPos = pb.deltaRatioPrev.distribution[distributionKeyPos]
    const outPullbackDistNeg = pb.deltaRatioPrev.distribution[distributionKeyNeg]
    const outPullbackTotalProb = prob * outPullbackProb
    const outPullbackMinDpr = outPullbackDpr - outPullbackDev * exitDistMultIndex
    const outPullbackMaxDpr = outPullbackDpr + outPullbackDev * exitDistMultIndex
    const outPullbackBaseProb = outPullbackTotalProb * outPullbackDistPos[0]
    const outPullbackMinProb = outPullbackTotalProb * (1 - outPullbackDistNeg[exitDistMultIndex])
    const outPullbackMaxProb = outPullbackTotalProb * outPullbackDistPos[exitDistMultIndex]
    const outPullbackMaxDiff = pb.maxDiffPercent[valueKey]
    const outPullbackMaxDiffDev = pb.maxDiffPercent[distributionKey]

    let mv = cluster.outcomes.move
    if (!mv.count) {
      mv = fallbacks.move
    }
    const outMoveProb = mv.count / cluster.stats.count
    const outMoveDpr = mv.deltaRatioPrev[valueKey]
    const outMoveDev = mv.deltaRatioPrev[distributionKey]
    const outMoveDist = mv.deltaRatioPrev.distribution[distributionKey]
    const outMoveDistPos = mv.deltaRatioPrev.distribution[distributionKeyPos]
    const outMoveDistNeg = mv.deltaRatioPrev.distribution[distributionKeyNeg]
    const outMoveTotalProb = prob * outMoveProb
    const outMoveMinDpr = outMoveDpr - outMoveDev * exitDistMultIndex
    const outMoveMaxDpr = outMoveDpr + outMoveDev * exitDistMultIndex
    const outMoveBaseProb = outMoveTotalProb * outMoveDistPos[0]
    const outMoveMinProb = outMoveTotalProb * (1 - outMoveDistNeg[exitDistMultIndex])
    const outMoveMaxProb = outMoveTotalProb * outMoveDistPos[exitDistMultIndex]
    const outMoveMaxDiff = mv.maxDiffPercent[valueKey]
    const outMoveMaxDiffDev = mv.maxDiffPercent[distributionKey]

    const result = {
      initial: {
        count: cluster.stats.count,
        prob,
        dpr,
        dev,
        dist,
        distPos,
        distNeg,
        minDpr,
        maxDpr,
        baseProb,
        minProb,
        maxProb,
      },
      outcomes: {
        pullback: {
          count: cluster.outcomes.pullback.count, //pb.count,
          prob: outPullbackProb,
          dpr: outPullbackDpr,
          dev: outPullbackDev,
          dist: outPullbackDist,
          distPos: outPullbackDistPos,
          distNeg: outPullbackDistNeg,
          totalProb: outPullbackTotalProb,
          minDpr: outPullbackMinDpr,
          maxDpr: outPullbackMaxDpr,
          baseProb: outPullbackBaseProb,
          minProb: outPullbackMinProb,
          maxProb: outPullbackMaxProb,
          maxDiff: outPullbackMaxDiff,
          maxDiffDev: outPullbackMaxDiffDev,
        },
        move: {
          count: cluster.outcomes.move.count, //mv.count,
          prob: outMoveProb,
          dpr: outMoveDpr,
          dev: outMoveDev,
          dist: outMoveDist,
          distPos: outMoveDistPos,
          distNeg: outMoveDistNeg,
          totalProb: outMoveTotalProb,
          minDpr: outMoveMinDpr,
          maxDpr: outMoveMaxDpr,
          baseProb: outMoveBaseProb,
          minProb: outMoveMinProb,
          maxProb: outMoveMaxProb,
          maxDiff: outMoveMaxDiff,
          maxDiffDev: outMoveMaxDiffDev,
        },
      }
    }

    details.clusters.push(result)


    // console.log('--------------------------------')
    // console.log('prediction', 'probability', prob * 100, 'xR', dpr, 'dist', dist, 'minDpr', minDpr, 'minProb', minProb, 'maxDpr', maxDpr, 'maxProb', maxProb)
    // console.log('outPullback', 'probability', outPullbackTotalProb * 100, 'xR', outPullbackDpr, 'dist', outPullbackDist,
    //   'minDpr', outPullbackMinDpr, 'minProb', outPullbackMinProb, 'maxDpr', outPullbackMaxDpr, 'maxProb', outPullbackMaxProb)
    // console.log('outMove', 'probability', outMoveTotalProb * 100, 'xR', outMoveDpr, 'dist', outMoveDist, outMoveDist, 'minDpr',
    //   outMoveMinDpr, 'minProb', outMoveMinProb, 'maxDpr', outMoveMaxDpr, 'maxProb', outMoveMaxProb)
  }

  return details

}

function ratioToPercentDetails(details, percent) {
  const keysToConvert = [
    'dpr',
    'dev',
    'minDpr',
    'maxDpr'
  ]

  const newDetails = JSON.parse(JSON.stringify(details))


  const results = []

  for (const cluster of newDetails.clusters) {
    const result = JSON.parse(JSON.stringify(cluster))
    try {
      for (const key in cluster.initial) {
        if (keysToConvert.includes(key)) {
          result.initial[key] = cluster?.initial[key] * percent
        }
      }

      const initialMult = cluster?.initial.dpr * percent

      for (const key in cluster.outcomes.move) {
        if (keysToConvert.includes(key)) {
          result.outcomes.move[key] = cluster?.outcomes?.move[key] * initialMult
        }
      }
      for (const key in cluster.outcomes.pullback) {
        if (keysToConvert.includes(key)) {
          result.outcomes.pullback[key] = cluster?.outcomes?.pullback[key] * initialMult
        }
      }
      results.push(result)
    } catch (error) {
      console.log('ratioToPercentDetails error', details, error)
    }
  }

  newDetails.clusters = results

  return newDetails
}

export function findClosestClusters(details, wave, calculateOpts) {
  const {
    valueKey,
    distributionKey,
    distributionKeyPos,
    distributionKeyNeg,
  } = calculateOpts

  const fieldsWeights = [
    {
      key: 'dpr',
      waveKey: 'deltaPercent',
      weight: 1
    }
  ]

  const results = []

  for (let i = 0; i < details.clusters.length; i++) {
    const cluster = details.clusters[i]

    let score = 0
    for (const field of fieldsWeights) {
      const clusterValue = cluster.initial[field.key]
      const waveValue = wave[field.waveKey]

      const distance = Math.abs(clusterValue - waveValue)
      score += distance * field.weight
    }

    results.push({
      index: i,
      score,
      cluster,
    })
  }

  results.sort((a, b) => a.score - b.score)

  return results
}

function getClusterExpectancy(clusterDetails, options) {
  const { stopMultiplier, takeShift, commission } = options;
  const enterDistMultIndex = options.enterDistMultIndex || 1
  const exitDistMultIndex = options.exitDistMultIndex || 1

  const clusterExpectancyResults = [];

  for (const cluster of clusterDetails.clusters) {
    const lossSize = cluster.initial.dev * stopMultiplier;
    const probLoss = 1 - cluster.initial.distPos[enterDistMultIndex];
    const probNonLoss = 1 - probLoss;

    const pb = cluster.outcomes.pullback
    const mv = cluster.outcomes.move

    const smallWinSize = pb.dpr + (pb.dev * takeShift)
    const bigWinSize = mv.dpr + (mv.dev * takeShift)

    const totalWinOutcomes = pb.count + mv.count;
    const smallWinOutcomeRatio = pb.prob
    const bigWinOutcomeRatio = mv.prob

    const takeIndex = Math.max(0, Math.round(Math.abs(takeShift)));
    const probTakeSmallWinOrLess = (pb.distPos[takeIndex] || 0) - (pb.distNeg[takeIndex + 1] || 0);
    const probTakeSmallWinOrMore = 1 - (pb.dist[takeIndex] || 0)

    const probTakeBigWinOrLess = (mv.distPos[takeIndex] || 0) - (mv.distNeg[takeIndex + 1] || 0);
    const probTakeBigWinOrMore = 1 - (mv.distPos[takeIndex] || 0);

    const probBigWin = probNonLoss * bigWinOutcomeRatio * probTakeBigWinOrLess;
    const probSmallWin = probNonLoss * (
      (smallWinOutcomeRatio * probTakeSmallWinOrLess) +
      (bigWinOutcomeRatio * (1 - probTakeBigWinOrLess))
    );

    const probScratch = probNonLoss - (probBigWin + probSmallWin);

    // Trailing SL
    const smallTSL = pb.maxDiff * 2 + pb.maxDiffDev
    const bigTSL = mv.maxDiff * 2 + mv.maxDiffDev
    const trailingSL = Math.max(smallTSL, bigTSL)

    // 1. Рассчитываем предполагаемую прибыль для "царапающей" сделки
    //    на основе допущения "цена прошла полпути до тейка".
    const trailingProfit_for_small = (smallWinSize / 2) - smallTSL;
    const trailingProfit_for_big = (bigWinSize / 2) - bigTSL;

    // 2. Усредняем результат, взвешивая по вероятности каждого исхода (pullback или move).
    //    smallWinOutcomeRatio и bigWinOutcomeRatio у вас уже рассчитаны.
    const weightedAvgTrailingProfit =
      (smallWinOutcomeRatio * trailingProfit_for_small) +
      (bigWinOutcomeRatio * trailingProfit_for_big);

    // 3. Обновляем итоговую формулу матожидания.
    const grossExpectancy =
      (probBigWin * bigWinSize) +
      (probSmallWin * smallWinSize) -
      (probLoss * lossSize) + // Убрали вычитание scratchLoss
      (probScratch * weightedAvgTrailingProfit); // Добавили новый, динамический результат

    const netExpectancy = grossExpectancy - commission;

    clusterExpectancyResults.push({
      cluster,
      netExpectancy,
      winRate: probBigWin + probSmallWin,
      lossRate: probLoss,
      avgWin: (probBigWin * bigWinSize + probSmallWin * smallWinSize) / (probBigWin + probSmallWin),
      avgLoss: lossSize,
      enter: cluster.initial.dpr,
      enterDev: cluster.initial.dev * enterDistMultIndex,
      stopLoss: lossSize,
      smallTSL,
      bigTSL,
      trailingSL,
      target1: pb.dpr + pb.dev * takeShift,
      target1Dev: pb.dev * exitDistMultIndex,
      target2: mv.dpr + mv.dev * takeShift,
      target2Dev: mv.dev * exitDistMultIndex,
      prob: cluster.initial.prob,
      rrRatio: (probBigWin * bigWinSize + probSmallWin * smallWinSize) / (probLoss * lossSize),
      // 
      // winRate: probTrueWin,
      // avgWin: weightedAvgWin,
      // enter: setupData.deltaPercent[valueKey],
      // enterRatio: setupData.deltaRatioPrev[valueKey],
      // stopLoss,
      // smallTSL,
      // bigTSL,
      // trailingSL,
      // smallWinRate: probTakeSmallWin,
      // bigWinRate: probTakeBigWin,
      // enterCount: setupData?.count,
    });
  }

  return clusterExpectancyResults
}

export function getGroupedOutcomes(clustersPaths, clusterOutcomes) {
  const getDeltaPercent = (path) => path.split('.').reduce((o, k) => o?.[k], clusterOutcomes.deltaPercent);
  const getDeltaRatioPrev = (path) => path.split('.').reduce((o, k) => o?.[k], clusterOutcomes.deltaRatioPrev);

  const results = {}

  for (const key in clustersPaths) {
    if (key === 'currentType') {
      results[key] = clustersPaths[key]
      continue
    }
    const variants = []

    for (const p of clustersPaths[key]) {
      const infoPercent = getDeltaPercent(p)
      const infoRatio = getDeltaRatioPrev(p)
      variants.push({
        path: p,
        deltaPercent: infoPercent,
        deltaRatioPrev: infoRatio,
      })
    }

    results[key] = variants
  }

  return results
}

export function getClustersPaths(waves) {
  const lastWave = waves[waves.length - 1];
  const prevWave = waves[waves.length - 2];
  const prePrevWave = waves[waves.length - 3];


  const pathsPrev = [
    `${prevWave.type}.${prePrevWave.type}${prePrevWave.direction.charAt(0).toUpperCase() + prePrevWave.direction.slice(1)}`,
    `${prevWave.type}.${prePrevWave.type}`,
    `${prevWave.type}.${prePrevWave.direction}`,
    `${prevWave.type}.${prePrevWave.direction}_${prePrevWave.type}`,
    // `${prevWave.type}.any`
  ]
  // const pathsCurrent = [
  //   `${lastWave.type}.${prevWave.type}${prevWave.direction.charAt(0).toUpperCase() + prevWave.direction.slice(1)}`,
  //   `${lastWave.type}.${prevWave.type}`,
  //   `${lastWave.type}.${prevWave.direction}`,
  //   `${lastWave.type}.${prevWave.direction}_${prevWave.type}`,
  //   // `${lastWave.type}.any`
  // ]
  const pathsCurrentPullback = [
    `pullback.${prevWave.type}${prevWave.direction.charAt(0).toUpperCase() + prevWave.direction.slice(1)}`,
    `pullback.${prevWave.type}`,
    `pullback.${prevWave.direction}`,
    `pullback.${prevWave.direction}_${prevWave.type}`,
    // `pullback.any`
  ]
  const pathsCurrentMove = [
    `move.${prevWave.type}${prevWave.direction.charAt(0).toUpperCase() + prevWave.direction.slice(1)}`,
    `move.${prevWave.type}`,
    `move.${prevWave.direction}`,
    `move.${prevWave.direction}_${prevWave.type}`,
    // `move.any`
  ]

  const pathsNextPullbackMove = [
    `move.pullback${lastWave.direction.charAt(0).toUpperCase() + lastWave.direction.slice(1)}`,
    `move.pullback`,
    `move.${lastWave.direction}`,
    `move.${lastWave.direction}_pullback`,
    // `move.any`
  ]
  const pathsNextMoveMove = [
    `move.move${lastWave.direction.charAt(0).toUpperCase() + lastWave.direction.slice(1)}`,
    `move.move`,
    `move.${lastWave.direction}`,
    `move.${lastWave.direction}_move`,
    // `move.any`
  ]

  const pathsNextPullbackPullback = [
    `pullback.pullback${lastWave.direction.charAt(0).toUpperCase() + lastWave.direction.slice(1)}`,
    `pullback.pullback`,
    `pullback.${lastWave.direction}`,
    `pullback.${lastWave.direction}_pullback`,
    // `pullback.any`
  ]
  const pathsNextMovePullback = [
    `pullback.move${lastWave.direction.charAt(0).toUpperCase() + lastWave.direction.slice(1)}`,
    `pullback.move`,
    `pullback.${lastWave.direction}`,
    `pullback.${lastWave.direction}_move`,
    // `pullback.any`
  ]

  const clustersPaths = {
    currentType: lastWave.type,
    prev: pathsPrev,
    currentMove: pathsCurrentMove,
    currentPullback: pathsCurrentPullback,
    // next Type1 pre Type2
    nextMoveMove: pathsNextMoveMove,
    nextMovePullback: pathsNextMovePullback,
    nextPullbackMove: pathsNextPullbackMove,
    nextPullbackPullback: pathsNextPullbackPullback,
  }

  return clustersPaths
}

export const predictSequence = (waves, stats) => {
  const maxLength = stats.length;
  const recentSequence = waves.slice(-maxLength);

  const capitalizeFirstLetter = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  const results = [];

  for (let i = 1; i <= recentSequence.length && i <= maxLength; i++) {
    const key = recentSequence
      .slice(-i)
      .map(wave => `${wave.type || 'none'}${capitalizeFirstLetter(wave.direction || 'Any')}`)
      .join(' -> ');

    if (stats[i - 1]) {
      const matches = stats[i - 1].filter(item => item.sequence.startsWith(key));
      if (matches.length > 0) {
        const totalFrequency = matches.reduce((sum, match) => sum + match.frequency, 0);

        const prediction = matches.map(match => {
          const nextWaveSequence = match.sequence.split(' -> ');
          const nextWave = nextWaveSequence[i];

          // Определение типа и направления на основе известных значений
          let nextType = 'none';
          let nextDirection = 'Unknown';

          if (nextWave.startsWith('move')) {
            nextType = 'move';
          } else if (nextWave.startsWith('pullback')) {
            nextType = 'pullback';
          }

          if (nextWave.endsWith('Up')) {
            nextDirection = 'up';
          } else if (nextWave.endsWith('Down')) {
            nextDirection = 'down';
          }

          return {
            nextWave: nextWave || 'Unknown',
            type: nextType,
            direction: nextDirection,
            probability: match.frequency / totalFrequency,
          };
        }).sort((a, b) => b.probability - a.probability);

        const result = {
          sequence: key,
          prediction
        }

        results.push(result);

        // console.log('predictSequence recentSequence', i, key, result.prediction[0])
      }
    }
  }

  return results;
};

// *************************************

export function calculateFadeExpectancy(stats, config, options = {
  stopMultiplier: 1,
  takeShift: 0,
  commission: 0.001,
  averagingMode: 'median'
}) {
  try {
    const { stopMultiplier, takeShift, commission, averagingMode } = options;
    const get = (path) => path.split('.').reduce((o, k) => o?.[k], stats);

    let valueKey = 'median'
    let distributionKey = 'mad'
    let distributionKeyPos = 'madPos'
    if (averagingMode === 'median') {
      valueKey = 'median'
      distributionKey = 'mad'
      distributionKeyPos = 'madPos'
    } else if (averagingMode === 'avg') {
      valueKey = 'avg'
      distributionKey = 'stdDev'
      distributionKeyPos = 'stdDevPos'
    }

    // --- Шаг 1: Параметры Убытка ---
    const setupData = get(config.setupWavePath);
    if (!setupData?.count || !setupData.deltaPercent?.distribution?.[distributionKey]) return null;

    const lossSize = setupData.deltaPercent?.[distributionKey] * stopMultiplier;
    const stopLoss = lossSize // setupData.deltaPercent[valueKey] + lossSize;

    const stopIndex = Math.max(0, Math.round(stopMultiplier));
    const probLoss = (1 - (setupData.deltaPercent.distribution[distributionKeyPos][stopIndex] || 0));
    if (probLoss < 0 || probLoss >= 1) return null;

    // --- Шаг 2: Параметры Выигрыша ---
    const smallWinData = get(config.smallWinOutcomePath);
    const bigWinData = get(config.bigWinOutcomePath);
    if (!smallWinData?.count || !bigWinData?.count) return null;

    const smallWinSize = smallWinData.deltaPercent[valueKey] + smallWinData.deltaPercent[distributionKey] * takeShift;
    const smallWinRatio = smallWinData.deltaRatioPrev[valueKey] + smallWinData.deltaRatioPrev[distributionKey] * takeShift;
    const bigWinSize = bigWinData.deltaPercent[valueKey] + bigWinData.deltaPercent[distributionKey] * takeShift;
    const bigWinRatio = bigWinData.deltaRatioPrev[valueKey] + bigWinData.deltaRatioPrev[distributionKey] * takeShift;

    // --- Шаг 3: Расчет вероятностей ---
    const probNonLoss = 1 - probLoss;
    const totalWinOutcomes = smallWinData.count + bigWinData.count;
    const smallWinOutcomeRatio = totalWinOutcomes > 0 ? smallWinData.count / totalWinOutcomes : 0;
    const bigWinOutcomeRatio = 1 - smallWinOutcomeRatio;
    const takeIndex = Math.max(0, Math.round(Math.abs(takeShift)));

    const probTakeSmallWin = takeShift >= 0
      ? (1 - smallWinData.deltaPercent.distribution[distributionKeyPos][takeIndex]) || 0
      : (smallWinData.deltaPercent.distribution[distributionKeyPos][takeIndex]) || 0
    const probTakeBigWin = takeShift >= 0
      ? (1 - bigWinData.deltaPercent.distribution[distributionKeyPos][takeIndex]) || 0
      : (bigWinData.deltaPercent.distribution[distributionKeyPos][takeIndex]) || 0

    // Ваша сложная логика вероятностей остается нетронутой
    const finalProb_SmallWin_case1 = probNonLoss * smallWinOutcomeRatio * probTakeSmallWin;
    const finalProb_SmallWin_case2 = probNonLoss * bigWinOutcomeRatio * (1 - probTakeBigWin) * smallWinOutcomeRatio * probTakeSmallWin;
    const finalProb_SmallWin = Math.min(1, finalProb_SmallWin_case1 + finalProb_SmallWin_case2);
    const finalProb_BigWin = Math.min(1, probNonLoss * bigWinOutcomeRatio * probTakeBigWin);
    const probTrueWin = Math.min(1, finalProb_SmallWin + finalProb_BigWin);

    // Вероятность "царапающей" сделки остается, но ее результат изменится
    const probScratch = probNonLoss - probTrueWin;
    // const scratchLossSize = lossSize * 0.5; // ИЗМЕНЕНИЕ: Эта строка больше не нужна

    // Trailing SL параметры остаются, как вы их определили
    const smallTSL = smallWinData.maxDiffPercent.avg * 2 + smallWinData.maxDiffPercent.stdDev
    const bigTSL = bigWinData.maxDiffPercent.avg * 2 + bigWinData.maxDiffPercent.stdDev
    const trailingSL = Math.max(smallTSL, bigTSL)

    // --- Шаг 4: Расчет итогового матожидания ---

    // ИЗМЕНЕНИЕ: Рассчитываем динамический результат для "царапающей" сделки
    const trailingProfit_for_small = (smallWinSize / 2) - smallTSL;
    const trailingProfit_for_big = (bigWinSize / 2) - bigTSL;
    const weightedAvgTrailingProfit = (smallWinOutcomeRatio * trailingProfit_for_small) + (bigWinOutcomeRatio * trailingProfit_for_big);

    // ИЗМЕНЕНИЕ: Обновляем формулу, заменяя `scratchLossSize` на `weightedAvgTrailingProfit`
    const grossExpectancy =
      (finalProb_BigWin * bigWinSize) +
      (finalProb_SmallWin * smallWinSize) -
      (probLoss * lossSize) + // Убрали убыток от scratch
      (probScratch * weightedAvgTrailingProfit); // Добавили новый, динамический результат от scratch

    const netExpectancy = grossExpectancy - commission;

    const weightedAvgWin = probTrueWin > 0
      ? ((finalProb_BigWin * bigWinSize) + (finalProb_SmallWin * smallWinSize)) / probTrueWin
      : 0;

    // ИЗМЕНЕНИЕ: Возвращаем ОБЪЕКТ В ТОЧНОСТИ КАК В ВАШЕМ ПРИМЕРЕ
    return {
      title: config.title,
      winRate: probTrueWin,
      scratchRate: probScratch,
      lossRate: probLoss,
      avgWin: weightedAvgWin,
      avgLoss: lossSize,
      enter: setupData.deltaPercent[valueKey],
      enterRatio: setupData.deltaRatioPrev[valueKey],
      stopLoss,
      smallTSL,
      bigTSL,
      trailingSL,
      target1: smallWinSize,
      targetRatio1: smallWinRatio,
      target2: bigWinSize,
      targetRatio2: bigWinRatio,
      smallWinRate: probTakeSmallWin,
      bigWinRate: probTakeBigWin,
      netExpectancy,
      depth: config.depth,
      enterCount: setupData?.count,
    };
  } catch (e) {
    console.error("Error calculating expectancy for:", config.title, e);
    return null;
  }
}


export function calculateFadeExpectancy2(stats, config, options = {
  stopMultiplier: 1,
  takeShift: 0,
  commission: 0.001,
  averagingMode: 'median'
}) {
  try {
    const { stopMultiplier, takeShift, commission, averagingMode } = options;
    const get = (path) => path.split('.').reduce((o, k) => o?.[k], stats);

    let valueKey = 'median'
    let distributionKey = 'mad'
    let distributionKeyPos = 'madPos'
    if (averagingMode === 'median') {
      valueKey = 'median'
      distributionKey = 'mad'
      distributionKeyPos = 'madPos'
    } else if (averagingMode === 'avg') {
      valueKey = 'avg'
      distributionKey = 'stdDev'
      distributionKeyPos = 'stdDevPos'
    }

    // --- Шаг 1: Параметры Убытка ---
    const setupData = get(config.setupWavePath);
    if (!setupData?.count || !setupData.deltaPercent?.distribution?.[distributionKey]) return null;

    const lossSize = setupData.deltaPercent?.[distributionKey] * stopMultiplier;
    const stopLoss = lossSize // setupData.deltaPercent[valueKey] + lossSize;

    const stopIndex = Math.max(0, Math.round(stopMultiplier));
    const probLoss = (1 - (setupData.deltaPercent.distribution[distributionKeyPos][stopIndex] || 0));
    if (probLoss < 0 || probLoss >= 1) return null;

    // --- Шаг 2: Параметры Выигрыша ---
    const smallWinData = get(config.smallWinOutcomePath);
    const bigWinData = get(config.bigWinOutcomePath);
    if (!smallWinData?.count || !bigWinData?.count) return null;

    const smallWinSize = smallWinData.deltaPercent[valueKey] + smallWinData.deltaPercent[distributionKey] * takeShift;
    const smallWinRatio = smallWinData.deltaRatioPrev[valueKey] + smallWinData.deltaRatioPrev[distributionKey] * takeShift;
    const bigWinSize = bigWinData.deltaPercent[valueKey] + bigWinData.deltaPercent[distributionKey] * takeShift;
    const bigWinRatio = bigWinData.deltaRatioPrev[valueKey] + bigWinData.deltaRatioPrev[distributionKey] * takeShift;

    // --- Шаг 3: Расчет вероятностей ---

    // 3.1. Вероятность того, что сделка НЕ будет убыточной
    const probNonLoss = 1 - probLoss;

    // 3.2. Вероятность того, какой тип волны последует (малый или большой выигрыш)
    const totalWinOutcomes = smallWinData.count + bigWinData.count;
    const smallWinOutcomeRatio = totalWinOutcomes > 0 ? smallWinData.count / totalWinOutcomes : 0;
    const bigWinOutcomeRatio = 1 - smallWinOutcomeRatio;

    // 3.3. Вероятность ВЗЯТИЯ тейк-профита для каждого типа исхода
    // Используем ваши данные: шанс на тейк = % попадания в +/- N MAD от медианы
    const takeIndex = Math.max(0, Math.round(Math.abs(takeShift)));

    const probTakeSmallWin = takeShift >= 0
      ? (1 - smallWinData.deltaPercent.distribution[distributionKeyPos][takeIndex]) || 0
      : (smallWinData.deltaPercent.distribution[distributionKeyPos][takeIndex]) || 0

    const probTakeBigWin = takeShift >= 0
      ? (1 - bigWinData.deltaPercent.distribution[distributionKeyPos][takeIndex]) || 0
      : (bigWinData.deltaPercent.distribution[distributionKeyPos][takeIndex]) || 0
    // const probTakeSmallWin = (smallWinData.deltaPercent.distribution.[distributionKey][takeShift] || 0);
    // const probTakeBigWin = (bigWinData.deltaPercent.distribution.[distributionKey][takeShift] || 0);

    // 3.4. Итоговые вероятности для каждого из 4-х сценариев
    // Условие: сделка не убыточная И это был исход "малый выигрыш" И мы взяли тейк
    // const finalProb_SmallWin = probNonLoss * smallWinOutcomeRatio * probTakeSmallWin;
    const finalProb_SmallWin_case1 = probNonLoss * smallWinOutcomeRatio * probTakeSmallWin;
    const finalProb_SmallWin_case2 = probNonLoss * bigWinOutcomeRatio * (1 - probTakeBigWin) * smallWinOutcomeRatio * probTakeSmallWin;
    const finalProb_SmallWin = Math.min(1, finalProb_SmallWin_case1 + finalProb_SmallWin_case2);
    // Условие: сделка не убыточная И это был исход "большой выигрыш" И мы взяли тейк
    const finalProb_BigWin = Math.min(1, probNonLoss * bigWinOutcomeRatio * probTakeBigWin);

    // Вероятность реального выигрыша (сумма двух успешных исходов)
    const probTrueWin = Math.min(1, finalProb_SmallWin + finalProb_BigWin);

    // Вероятность безубытка (сделка не убыточная, но тейк не взят)
    const probScratch = probNonLoss - probTrueWin;
    const scratchLossSize = lossSize * 0.5;

    // Trailing SL
    const smallTSL = smallWinData.maxDiffPercent.avg + smallWinData.maxDiffPercent.stdDev
    const bigTSL = bigWinData.maxDiffPercent.avg + bigWinData.maxDiffPercent.stdDev
    const trailingSL = Math.max(smallTSL, bigTSL)


    // --- Шаг 4: Расчет итогового матожидания ---
    const grossExpectancy =
      (finalProb_BigWin * bigWinSize) +
      (finalProb_SmallWin * smallWinSize) -
      (probLoss * lossSize) -
      (probScratch * scratchLossSize);

    const netExpectancy = grossExpectancy - commission;

    // Средний выигрыш считаем только по тем сделкам, где он был
    const weightedAvgWin = probTrueWin > 0
      ? ((finalProb_BigWin * bigWinSize) + (finalProb_SmallWin * smallWinSize)) / probTrueWin
      : 0;

    return {
      title: config.title,
      winRate: probTrueWin,
      scratchRate: probScratch,
      lossRate: probLoss,
      avgWin: weightedAvgWin,
      avgLoss: lossSize,
      enter: setupData.deltaPercent[valueKey],
      enterRatio: setupData.deltaRatioPrev[valueKey],
      stopLoss,
      smallTSL,
      bigTSL,
      trailingSL,
      target1: smallWinSize,
      targetRatio1: smallWinRatio,
      target2: bigWinSize,
      targetRatio2: bigWinRatio,
      smallWinRate: probTakeSmallWin,
      bigWinRate: probTakeBigWin,
      netExpectancy,
      depth: config.depth,
      enterCount: setupData?.count,
    };
  } catch (e) {
    console.error("Error calculating expectancy for:", config.title, e);
    return null;
  }
}

/**
 * Реализует трехуровневое Байесовское усреднение для ВСЕХ числовых метрик объекта expectancy.
 * @param {Array<object>} strategyResults - Массив с результатами от calculateExpectancy.
 * @returns {object|null} - Финальный объект с усредненными метриками или null.
 */
export function getBlendedExpectancy(strategyResults) {
  if (!strategyResults || strategyResults.length === 0) {
    return null;
  }

  // Сортируем стратегии по уровню детализации
  const sortedStrategies = [...strategyResults].sort((a, b) => a.expectancy.depth - b.expectancy.depth);

  // --- Шаг 1: Берем самый общий прогноз как базу ---
  const baseResult = sortedStrategies[0];
  if (!baseResult || baseResult.expectancy.enterCount === 0) {
    return null;
  }

  // Создаем объект для хранения взвешенных сумм. Инициализируем его базовыми значениями.
  const weightedSums = {};
  let totalWeight = baseResult.expectancy.enterCount;

  for (const key in baseResult.expectancy) {
    if (typeof baseResult.expectancy[key] === 'number') {
      weightedSums[key] = baseResult.expectancy[key] * totalWeight;
    }
  }

  // --- Шаг 2: Последовательно "обновляем" прогноз, проходя по остальным уровням ---
  for (let i = 1; i < sortedStrategies.length; i++) {
    const currentResult = sortedStrategies[i];
    const currentWeight = currentResult.expectancy.enterCount;

    if (currentWeight === 0) {
      continue;
    }

    // Обновляем каждую числовую метрику
    for (const key in currentResult.expectancy) {
      if (typeof currentResult.expectancy[key] === 'number' && weightedSums.hasOwnProperty(key)) {
        weightedSums[key] += currentResult.expectancy[key] * currentWeight;
      }
    }

    totalWeight += currentWeight;
  }

  // --- Шаг 3: Рассчитываем итоговое средневзвешенное значение для каждой метрики ---
  const blendedExpectancy = {};
  for (const key in weightedSums) {
    blendedExpectancy[key] = weightedSums[key] / totalWeight;
  }

  // Дополняем объект нечисловыми данными для консистентности
  blendedExpectancy.title = sortedStrategies[sortedStrategies.length - 1].title;
  blendedExpectancy.depth = sortedStrategies[sortedStrategies.length - 1].expectancy.depth;
  blendedExpectancy.totalWeight = totalWeight;

  return blendedExpectancy;
}

export function groupUpdates(resample, startTime, updates) {
  const st = parseInt(startTime)
  let nextSampleTime = st + resample * 1000 // group by resample seconds
  const minuteUpdates = {}

  minuteUpdates[nextSampleTime] = minuteUpdates[nextSampleTime] || []

  for (const update of updates) {
    const time = update.time
    if (time > nextSampleTime) {
      nextSampleTime = nextSampleTime + resample * 1000
      minuteUpdates[nextSampleTime] = minuteUpdates[nextSampleTime] || []
    }
    minuteUpdates[nextSampleTime].push(update)
  }

  return minuteUpdates
}

export function getSamplesFromUpdates(groupedUpdates) {
  const resampledUpdates = []
  for (let updateEnd in groupedUpdates) {
    const updates = groupedUpdates[updateEnd]
    const sample = { time: updateEnd, bids: {}, asks: {} }
    for (const u of updates) {
      sample.bids = { ...sample.bids, ...u.bids }
      sample.asks = { ...sample.asks, ...u.asks }
    }
    // checkSample(sample)
    resampledUpdates.push(sample)
  }
  return resampledUpdates
}

function checkSample(sample) {
  let bestAsk = Infinity
  for (const lvl in sample.asks) {
    const volume = sample.asks[lvl]
    const v = parseFloat(volume)
    const p = parseFloat(lvl)
    if (v === 0) {
      // do not remove now
      // delete sample.asks[lvl]
    } else if (p < bestAsk) {
      bestAsk = p
      sample.bestAsk = lvl
    }
  }

  let bestBid = -Infinity
  for (const lvl in sample.bids) {
    const volume = sample.bids[lvl]
    const v = parseFloat(volume)
    const p = parseFloat(lvl)
    if (v === 0) {
      // do not remove now
      // delete sample.bids[lvl]
    } else if (p > bestBid) {
      bestBid = p
      sample.bestBid = lvl
    }
  }
  // console.log('sample', sample)
  //candleStart, updateEnd, bestAsk, bestBid)
  if (bestAsk <= bestBid) {
    console.error('sample invalid', sample)
    // candleStart, updateEnd, bestAsk, bestBid)
  }
}


export const groupPrices = (data, decimals, useAvg = false) => {
  // const factor = Math.pow(10, decimals);
  const groupedTrades = {};
  const groupedAvg = {};
  const groups = {};

  for (const lvl in data) {
    const price = parseFloat(lvl);
    const volume = data[lvl];
    const roundedPrice = Number(price.toPrecision(decimals))
    // const roundedPrice = Math.round(price / factor) * factor;
    // console.log('roundedPrice', roundedPrice)
    groups[roundedPrice] = groups[roundedPrice] || [];
    groups[roundedPrice].push({ price, volume })

    if (!groupedTrades[roundedPrice]) {
      groupedTrades[roundedPrice] = volume
    } else {
      groupedTrades[roundedPrice] += volume
    }
  }

  for (const group in groups) {
    if (useAvg) {
      const avgPrice = groups[group].reduce((a, b) => a + b.price, 0) / groups[group].length;
      groupedAvg[avgPrice] = groupedTrades[group]
    } else {
      const sumPriceVolume = groups[group].reduce((acc, item) => acc + item.price * item.volume, 0);
      const sumVolume = groups[group].reduce((acc, item) => acc + item.volume, 0);
      const weightedAvgPrice = sumPriceVolume / sumVolume;
      groupedAvg[weightedAvgPrice] = groupedTrades[group];
    }
  }
  // console.log('groups', groups)
  // console.log('groupedAvg', groupedAvg)

  return groupedAvg;
}

export function percentile(values, p) {
  values.sort((a, b) => a - b);
  const index = (p / 100) * (values.length - 1);

  if (Math.floor(index) === index) {
    return values[index];
  } else {
    const i = Math.floor(index);
    return values[i] + (values[i + 1] - values[i]) * (index - i);
  }
}


export function getApiEndpoint(env) {
  let apiBase = 'http://127.0.0.1:3000'
  // if (env === 'TEST') apiBase = 'https://bot.elmeno.dev'
  if (env === 'PROD') apiBase = 'https://dxbot.elmeno.dev'
  return apiBase
}

export function getWsEndpoint(env) {
  let apiBase = 'ws://127.0.0.1:3000'
  // if (env === 'TEST') apiBase = 'wss://bot.elmeno.dev'
  if (env === 'PROD') apiBase = 'wss://dxbot.elmeno.dev'
  return apiBase
}